/**
 * Underscore's debounce function
 *
 * @param     func : {function}
 * @param     wait : {Integer} 
 * @param     immediate : {Boolean}
 */
export function debounce(func, wait, immediate) {
    let timeout;

    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;
            if (!immediate) { 
                func.apply(context, args);
            }
        };
        const callNow = immediate && !timeout;

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
}

/**
 * Uses the global variable set by octopus to determine the environment that
 * we're in so we can correctly set our API endpoints 
 */
const getHostForEnvironment = () => {
    return typeof ENDPOINT !== 'undefined' 
        ? ENDPOINT 
        : 'https://feedbackqa.eftours.com:8074'
};

/**
 * Returns a URI for the provided encrypted paramters based on the current environment
 *
 * @param {String} encryptedParameters 
 * @param {String} endPoint
 */
export const getAPIEncrypted = (encryptedParameters, endPoint = '') => {
    return `${getHostForEnvironment()}/api/survey/backup/${encryptedParameters}/${endPoint}`;
};

/**
 * Returns a URI for the provided paramters based on the current environment
 *
 * @param {string} endPoint
 * @param {Object} individualContext
 * @param {number} individualContext.prodTourID
 * @param {number} individualContext.individualID
 */
export const getAPI = (endPoint = '', {prodTourID, individualID}) => {
    return `${getHostForEnvironment()}/api/survey/prodTourId/${prodTourID}/individualId/${individualID}/${endPoint}`;
};

/**
 * Parses the search string in the URL for the parameter after
 * the supplied string, and returns that parameter/term/etc in lowerCase.
 *
 * @param     name : {String}
 * @param     ignoreCase : {Bool}
 */
export const getQueryParams = (name, ignoreCase = true) => {
    const newName = name.toLowerCase().replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + newName + '=([^&#]*)');
    const valueToSearch = (ignoreCase) ? location.search.toLowerCase() : location.search;
    const results = regex.exec(valueToSearch);

    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Loops through the various overall question objects and returns the one
 * that has a 'type' that matches the supplied type.
 * 
 * @param     questions : {Array}
 * @param     type : {String}
 */
export const getOverallQuestion = (questions, type) => {
    for (const question of questions) if (question.Type === type) return question;
};

/**
 * Returns a boolean representing whether or not the user agent of the
 * device is Android based.
 */
export const isAndroid = () => {
    return navigator && navigator.userAgent.toLowerCase().includes('android');
};

/**
 * One of many possible throttle function implementations..
 *
 * @param     func : {function}
 * @param     limit : {Integer} 
 */
export const throttle = (func, limit) => {
    let inThrottle;
    let lastFunc;
    let lastRan;

    return () => {
        const context = this;
        const args = arguments;

        if (!inThrottle) {
            func.apply(context, args);
            lastRan = Date.now();
            inThrottle = true;
        } else {
            clearTimeout(lastFunc);

            lastFunc = setTimeout(() => {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
};



// WEBPACK FOOTER //
// ./application/global/js/helpers.js